import { Controller } from "@hotwired/stimulus"

// Controls the toggling of content visibility
export default class extends Controller {
  toggle(event) {
    event.preventDefault()
    
    // Find the content element (next sibling after the button)
    const button = event.currentTarget
    const content = button.nextElementSibling
    
    // Toggle the 'is-hidden' class on the content
    content.classList.toggle('is-hidden')
    
    // Toggle the icon between down and up chevrons
    const icon = button.querySelector('.icon i')
    if (icon) {
      if (content.classList.contains('is-hidden')) {
        icon.classList.remove('fa-chevron-up')
        icon.classList.add('fa-chevron-down')
      } else {
        icon.classList.remove('fa-chevron-down')
        icon.classList.add('fa-chevron-up')
      }
    }
  }
}
